import { Affix, Button, Card, Form, Space } from "antd";
import { CERTIFICATE_OF_ORIGIN_FEE_LIST_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CertificateOfOriginFeeForm from "../CertificateOfOriginFeeForm";

const UpdateCertificateOfOriginFee = (props) => {
  const { width, viewMode } = props;
  const [editInfo, setEditInfo] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { certificateOfOriginFeeId } = useParams();

  const getCertificateOfOriginFeeInfo = useCallback(
    async (id) => {
      const query = `${CERTIFICATE_OF_ORIGIN_FEE_LIST_ENDPOINT}/${id}`;
      const response = await getData(query);

      if (response && response?.data?.code === 200) {
        const feeData = response?.data?.data;
        form.setFieldsValue({
          name: feeData?.name,
          description: feeData?.description,
        });
        setEditInfo(feeData);
      } else {
        HandleNotification(
          "error",
          "Error!",
          response?.message || "Failed to get certificate of origin fee data",
        );
      }
    },
    [form],
  );

  useEffect(() => {
    if (certificateOfOriginFeeId) {
      getCertificateOfOriginFeeInfo(certificateOfOriginFeeId);
    }
  }, [certificateOfOriginFeeId, getCertificateOfOriginFeeInfo]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/certificate-of-origin-fee");
  };

  const updateCertificateOfOriginFee = () => {
    form.submit();
  };

  // Download and print functionality can be added later if needed

  const ActionUI = () => {
    return (
      <Space>
        <Button size="small" key={1} danger onClick={() => discardForm()}>
          {viewMode ? "Back" : "Discard"}
        </Button>

        <Button
          size="small"
          key={2}
          type="primary"
          onClick={() => updateCertificateOfOriginFee()}
          hidden={viewMode}
        >
          Update Certificate of Origin Fee
        </Button>
      </Space>
    );
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={`${viewMode ? "View" : "Edit"} Certificate of Origin Fee`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </Affix>

      <CertificateOfOriginFeeForm
        form={form}
        isEdit={true}
        viewMode={viewMode}
        editInfo={editInfo}
      />
    </>
  );
};

export default UpdateCertificateOfOriginFee;
